import { Box } from "@@/shared/box";
import { HorizontalLine, VerticalDivider } from "@@/shared/dividers";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { Padding } from "@@/shared/padding";
import { TextBox } from "@@/shared/text";
import { useTranslate } from "@@/translations/use-translate";
import type { Product } from "@towni/common";
import * as React from "react";
import { useNavigate } from "react-router";
// import { useNavigate } from "react-router";

type Props = {
    readonly products: Product[];
};

const ProductList = ({ products }: Props) => {
    const translate = useTranslate();
    const navigate = useNavigate();

    return (
        <FlexColumn fillParentWidth>
            {products.map(product => {
                return (
                    <React.Fragment key={product._id}>
                        <Padding fillParentWidth leftRight={15} topBottom={10}>
                            <FlexRow fillParentWidth mainAxis="space-between">
                                <Box
                                    cursor="pointer"
                                    notSelectable
                                    onClick={() =>
                                        navigate(`/products/${product._id}`)
                                    }
                                    padding={{ leftRight: 15, topBottom: 10 }}>
                                    <TextBox
                                        text={translate(product.meta.title)}
                                        size="S"
                                        color="#ccc"
                                        padding={{ all: 0 }}
                                    />
                                    <VerticalDivider XXS />
                                    <TextBox
                                        text={product.meta.description}
                                        color="#444"
                                        size="S"
                                    />
                                </Box>
                            </FlexRow>
                        </Padding>
                        <HorizontalLine />
                    </React.Fragment>
                );
            })}
        </FlexColumn>
    );
};

export { ProductList };
